import { request } from "./http";

export interface PdlRecord {
  id:                 string;
  segment:            string;
  puissanceSouscrite: string;
  codePostal:         string;
  siteId:             string;
  sge:                boolean;
  source:             string; // "" | "enedis" | "deepki" | "engie"
  label:              string; // libellé libre (ex. "Bâtiment A")
  createdAt:          string;
  updatedAt:          string;
}

export interface PceRecord {
  id:         string;
  codePostal: string;
  siteId:     string;  // "" = non rattaché à un site
  source:     string;  // "" | "grdf" | "engie" — cf. CLAUDE.md, section "Migration ÉLEC + GAZ vers ts-ingest"
  label:      string;  // libellé libre (ex. "Bâtiment A")
  createdAt:  string;
  updatedAt:  string;
}

// ── PDL ───────────────────────────────────────────────────────────────────────

export function listPdl(): Promise<PdlRecord[]> {
  return request<PdlRecord[]>("/pdl");
}

export async function upsertPdl(
  pdl: Omit<PdlRecord, "createdAt" | "updatedAt">,
): Promise<PdlRecord> {
  return request<PdlRecord>("/pdl", {
    method: "POST",
    body:   JSON.stringify(pdl),
  });
}

export async function deletePdl(id: string): Promise<void> {
  await request<{ ok: boolean }>(`/pdl/${encodeURIComponent(id)}`, { method: "DELETE" });
}

// ── PCE ───────────────────────────────────────────────────────────────────────

export function listPce(): Promise<PceRecord[]> {
  return request<PceRecord[]>("/pce");
}

export async function upsertPce(
  pce: Omit<PceRecord, "createdAt" | "updatedAt">,
): Promise<PceRecord> {
  return request<PceRecord>("/pce", {
    method: "POST",
    body:   JSON.stringify(pce),
  });
}

export async function deletePce(id: string): Promise<void> {
  await request<{ ok: boolean }>(`/pce/${encodeURIComponent(id)}`, { method: "DELETE" });
}
